import OmbudsmanPage from './OmbudsmanPage';

export default OmbudsmanPage;
